import { useState, useEffect } from 'react';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

let optionsSet = false;
let loadPromise = null;

export function useGoogleMaps({ key, libraries, version = 'weekly' }) {
  const [state, setState] = useState({ googleMaps: null, error: null });

  useEffect(() => {
    if (!optionsSet) {
      setOptions({ key, v: version });
      optionsSet = true;
    }

    if (!loadPromise) {
      loadPromise = Promise.all(
        libraries.split(',').map((lib) => importLibrary(lib.trim()))
      );
    }

    loadPromise
      .then(() => setState({ googleMaps: window.google.maps, error: null }))
      .catch((error) => setState({ googleMaps: null, error }));
  }, [key, libraries, version]);

  return state;
}
